import Link from 'next/link'

import parseBreaks from '../../utils/parseBreaks'

const ThemeHeader = (props) => {

  const modifier = (props.content.color !== 'none') ? ` ThemeHeader--${props.content.color}` : ``

  const titleHTML = () => {
    return { __html: parseBreaks(props.content.title) }
  }

  const textHTML = () => {
    return { __html: props.content.text }
  }

  return (
    <div className={`ThemeHeader${modifier}`}>
      <div className="ThemeHeader-inner">
        <div className="ThemeHeader-intro">
          <div className="ThemeHeader-backButtonWrapper">
            <Link href={'/vision'}>
              <a className="ThemeHeader-backButton">
                <svg>
                  <use xlinkHref="#icon-chevron-right"/>
                </svg>
                <span>{props.title}</span>
              </a>
            </Link>
          </div>
          <div className="ThemeHeader-content">
            <div className="ThemeHeader-title">
              <h1 dangerouslySetInnerHTML={titleHTML()}/>
            </div>
            <div className="ThemeHeader-text" dangerouslySetInnerHTML={textHTML()}/>
          </div>
        </div>
        <div className="ThemeHeader-media">
          <div className="ThemeHeader-people">
            <div className="ThemeHeader-curator" style={{ backgroundColor: props.content.color }}>
              <img className="ThemeHeader-curatorImage" src={props.content.curatorImage[0].url}/>
            </div>
            <p className="ThemeHeader-curatedBy">
              <span className="ThemeHeader-author">Curated by {props.content.curator[0].name}</span>
              <span className="ThemeHeader-authorRole">— {props.content.curator[0].role}</span>
            </p>
          </div>
          {props.content.image[0] &&
          <div className="ThemeHeader-imageWrapper">
            <img src={props.content.image[0].url}/>
          </div>
          }
        </div>
      </div>
    </div>
  )
}

export default ThemeHeader
